import Script from 'next/script';
import { forwardRef, useEffect, useRef } from 'react';

import useIntersectionObserver from 'hooks/useIntersectionObserver';

import { sendEvent } from 'lib/gtag';

const GA_EVENT_CATEGORY = 'sidebar_store_coupons';
const MAX_POLLING_ATTEMPTS = 10;
const POLLING_INTERVAL = 200;

const CleverCoreAd = forwardRef((_, ref) => {
  const hasTrackedView = useRef(false);
  const pollingTimeoutRef = useRef(null);

  const checkAndTrackAdView = (attempts = 0) => {
    if (hasTrackedView.current || !ref?.current) {
      return;
    }

    const adContent =
      ref.current.querySelector('iframe') ||
      ref.current.querySelector('.clever-core-ads > *');

    if (adContent) {
      hasTrackedView.current = true;
      sendEvent({
        action: 'view_bet365_ad',
        category: GA_EVENT_CATEGORY,
      });
      return;
    }

    if (attempts < MAX_POLLING_ATTEMPTS) {
      pollingTimeoutRef.current = setTimeout(() => {
        checkAndTrackAdView(attempts + 1);
      }, POLLING_INTERVAL);
    }
  };

  useIntersectionObserver({
    target: ref,
    threshold: 0.5,
    onIntersect: () => {
      if (hasTrackedView.current || pollingTimeoutRef.current) {
        return;
      }
      checkAndTrackAdView(0);
    },
  });

  useEffect(
    () => () => {
      if (pollingTimeoutRef.current) {
        clearTimeout(pollingTimeoutRef.current);
      }
    },
    []
  );

  const onClickHandler = () => {
    sendEvent({
      action: 'click_bet365_ad',
      category: GA_EVENT_CATEGORY,
    });
  };

  return (
    <>
      <Script
        data-cfasync="false"
        id="clever-core"
        strategy="afterInteractive"
        type="text/javascript"
      >
        {`(function (document, window) {
          var a, c = document.createElement("script"), f = window.frameElement;
          c.id = "CleverCoreLoader99283";
          c.src = "https://scripts.cleverwebserver.com/d683e5401ba7899bf3d6d54e00287c5c.js";
          c.async = true;
          c.type = "text/javascript";
          c.setAttribute("data-target", window.name || (f && f.getAttribute("id")));
          c.setAttribute("data-callback", "put-your-callback-function-here");
          c.setAttribute("data-callback-url-click", "put-your-click-macro-here");
          c.setAttribute("data-callback-url-view", "put-your-view-macro-here");
          try {
            a = parent.document.getElementsByTagName("script")[0] || document.getElementsByTagName("script")[0];
          } catch (e) {
            a = false;
          }
          a || (a = document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]);
          a.parentNode.insertBefore(c, a);
        })(document, window);`}
      </Script>
      {/*
        eslint-disable-next-line
        jsx-a11y/click-events-have-key-events,
        jsx-a11y/no-static-element-interactions
      */}
      <div
        ref={ref}
        className="isolate hidden h-[300px] w-[300px] overflow-hidden md:block"
        style={{
          contain: 'style paint',
        }}
        onClick={onClickHandler}
      >
        <div className="clever-core-ads" />
      </div>
    </>
  );
});

CleverCoreAd.displayName = 'CleverCoreAd';

export default CleverCoreAd;
